import { useState, useCallback, useRef } from "react";
import style from "./Carousel.Module.css";
import { Lightbox } from "../Lightbox/Lightbox";

export const Carousel = ({ photos }) => {
    const [current, setCurrent] = useState(0);
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const touchStartX = useRef(null);

    const prev = useCallback(() => setCurrent(i => (i - 1 + photos.length) % photos.length), [photos.length]);
    const next = useCallback(() => setCurrent(i => (i + 1) % photos.length), [photos.length]);

    const onTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
    const onTouchEnd = (e) => {
        if (touchStartX.current === null) return;
        const diff = touchStartX.current - e.changedTouches[0].clientX;
        if (diff > 50) next();
        else if (diff < -50) prev();
        touchStartX.current = null;
    };

    return (
        <>
        <div className="carousel" onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
            {photos.map((photo, i) => (
                <div
                    key={i}
                    className={i === current ? "carousel-slide carousel-slide-active" : "carousel-slide"}
                >
                    <img className="carousel-bg" src={photo.image} alt="" aria-hidden="true" />
                    <img
                        className="carousel-img"
                        src={photo.image}
                        alt={photo.alt}
                        onClick={() => setLightboxOpen(true)}
                        style={{ cursor: 'zoom-in' }}
                    />
                </div>
            ))}
            <button className="carousel-btn carousel-prev" onClick={prev} aria-label="Previous">&#8249;</button>
            <button className="carousel-btn carousel-next" onClick={next} aria-label="Next">&#8250;</button>
            <div className="carousel-dots">
                {photos.map((_, i) => (
                    <span
                        key={i}
                        className={i === current ? "carousel-dot carousel-dot-active" : "carousel-dot"}
                        onClick={() => setCurrent(i)}
                        onTouchEnd={(e) => { e.stopPropagation(); setCurrent(i); }}
                    />
                ))}
            </div>
        </div>
        {lightboxOpen && (
            <Lightbox
                photos={photos}
                startIndex={current}
                onClose={() => setLightboxOpen(false)}
            />
        )}
        </>
    );
};
